// extracted by mini-css-extract-plugin
export default {"noBannerOnErrorPages":"Layout-noBannerOnErrorPages__vte4e"};